import { SVGIconComponent } from '../types';

export const motorcycleHelmet: SVGIconComponent = ({ title = '', ...props }) => (
  <svg data-dir="ltr" viewBox="0 0 15 12" {...props}>
    <title>{title}</title>
    <path d="M7.5 5.593c0-.433-.26-.82-.653-.986l-3.72-1.574C2.14 4.153 1.58 5.5 1.26 6.667h5.167c.593 0 1.073-.48 1.073-1.074Z" />
    <path d="M14.14 5.48C13.867 2.54 11.1.487 8.153.68 6.48.787 5.193 1.307 4.2 2.04l3.16 1.34a2.41 2.41 0 0 1 1.467 2.213A2.41 2.41 0 0 1 6.42 8H.973c-.14.873-.14 1.467-.14 1.467V10c0 .733.6 1.333 1.334 1.333h6.666A5.335 5.335 0 0 0 14.14 5.48Z" />
  </svg>
);
